import { MediaListItem as MediaListItemResp } from "@jconradi/tutu-porn-api-client/src/users"
import { useInView } from 'react-intersection-observer';
import { VideoPlayer } from "../Video/VideoPlayer";
import { Gallery } from "../Gallery/Gallery";
import { Transcoding } from "../Transcoding/Transcoding";
import { TrackingImage } from "../Tracking/TrackingImage";
import { MediaItemHeader } from "./MediaItemHeader";
import { RoundedLinkButton } from "../../Buttons/LinkButton";
import cls from 'clsx';
import { ImageMediaItem } from "./ImageMediaItem";
import Link from "next/link";
import { MediaType } from "@jconradi/tutu-porn-api-client/src/media";

export interface MediaItemProps {
    mediaListItem: MediaListItemResp;
    mediaClassName?: string;
    requireInViewToPlay?: boolean;
    className?: string;
}
export const MediaItem = ({ mediaListItem, mediaClassName, requireInViewToPlay = true, className }: MediaItemProps) => {
    const { info } = mediaListItem;
    const { ref: inViewRef, inView } = useInView({
        triggerOnce: false,
        rootMargin: '1000px 0px',
        
    });
    const { ref: mediaViewRef, inView: inMediaView } = useInView({
        triggerOnce: true,
        threshold: 1
    });
    let { width = 1, height = 1 } = info;

    const showMedia = requireInViewToPlay ? inView : true;

    return (
        <div ref={inViewRef} className={cls('bg-base-300 rounded-[24px] flex flex-col items-start overflow-hidden', {
            ['gallery']: mediaListItem.mediaType === MediaType.Gallery,
            ['shadow-sm']: mediaListItem.mediaType !== MediaType.Gallery
        }, className)}>
            <MediaItemHeader mediaListItem={mediaListItem} />
            <div ref={mediaViewRef} style={{
                aspectRatio: `${width} / ${height}`
            }} className={mediaClassName || "w-full max-h-[480px] relative"}>
                {showMedia && mediaListItem.isTranscoding &&
                    <Transcoding />
                }
                {showMedia && !mediaListItem.isTranscoding &&
                    <>
                        {(inMediaView || !requireInViewToPlay) && <TrackingImage media={mediaListItem} />}
                        
                        {mediaListItem.mediaType === "photo" && <ImageMediaItem media={mediaListItem} />}
                        {mediaListItem.mediaType === 'video' &&
                            <VideoPlayer autoPlayInView={requireInViewToPlay} media={mediaListItem} />
                        }
                        {mediaListItem.mediaType === 'gallery' &&
                            <Gallery media={mediaListItem} />
                        }
                    </>
                }
            </div>
            {mediaListItem.title &&
                <Link href={`/watch/${mediaListItem.slug}`}>
                    <h1 className="px-[15px] py-[8px] text-sm  font-semibold">{mediaListItem.title}</h1>
                </Link>
            }

            <div className="flex flex-row gap-x-2 gap-y-2 flex-wrap whitespace-normal px-[15px] py-[8px]">
                {mediaListItem.tags.map(tag => {
                    return (
                        <RoundedLinkButton key={tag.name} tag={tag.name} />
                    )
                })}
            </div>

        </div>
    )
}